import { lazyLoad } from 'utils/loadable';

export const PaymentCancelled = lazyLoad(
  () => import('./index'),
  module => module.PaymentCancelled,
);